<div class="modal-backdrop">
  <div class="modal-content">
    <div class="modal-header">
      <h2>Add User</h2>
    </div>
    
    <!-- Error message display -->
    @if (error()) {
    <div class="error-banner">
      {{ error() }}
    </div>
    }
    
    <form [formGroup]="userForm" (ngSubmit)="onSubmit()">
      <div class="form-group">
        <label for="email">Email</label>
        <input id="email" type="email" formControlName="email" required />
        @if (userForm.get('email')?.hasError('required') && userForm.get('email')?.touched) {
        <div class="error">
          Email is required
        </div>
        }
        @if (userForm.get('email')?.hasError('email') && userForm.get('email')?.touched) {
        <div class="error">
          Invalid email
        </div>
        }
      </div>

      <div class="form-group">
        <label for="displayName">Display Name</label>
        <input id="displayName" type="text" formControlName="displayName" maxlength="100" />
        @if (userForm.get('displayName')?.hasError('required') && userForm.get('displayName')?.touched) {
        <div class="error">Display name is required</div>
        }
        @if (userForm.get('displayName')?.hasError('maxlength') && userForm.get('displayName')?.touched) {
        <div class="error">Display name must be 100 characters or fewer</div>
        }
      </div>

      <div class="permissions-section">
        <h4>Page Access Permissions</h4>
        <div class="permissions-grid">
          <div class="permission-column">
            <label class="permission-item">
              <input type="checkbox" id="entities" formControlName="entities">
              <span class="checkmark"></span>
              Entities
            </label>
            <label class="permission-item">
              <input type="checkbox" id="invoices" formControlName="invoices">
              <span class="checkmark"></span>
              Invoices
            </label>
            <label class="permission-item">
              <input type="checkbox" id="assets" formControlName="assets">
              <span class="checkmark"></span>
              Assets
            </label>
            <label class="permission-item">
              <input type="checkbox" id="messages" formControlName="messages">
              <span class="checkmark"></span>
              Messages
            </label>
            <label class="permission-item">
              <input type="checkbox" id="shares" formControlName="shares">
              <span class="checkmark"></span>
              Shares
            </label>
          </div>
          <div class="permission-column">
            <label class="permission-item">
              <input type="checkbox" id="information" formControlName="information">
              <span class="checkmark"></span>
              Information
            </label>
            <label class="permission-item">
              <input type="checkbox" id="banking" formControlName="banking">
              <span class="checkmark"></span>
              Banking
            </label>
            <label class="permission-item">
              <input type="checkbox" id="loans" formControlName="loans">
              <span class="checkmark"></span>
              Loans
            </label>
            <label class="permission-item">
              <input type="checkbox" id="tasks" formControlName="tasks">
              <span class="checkmark"></span>
              Tasks
            </label>
          </div>
          <div class="permission-column">
            <label class="permission-item">
              <input type="checkbox" id="relatedParties" formControlName="relatedParties">
              <span class="checkmark"></span>
              Related Parties
            </label>
            <label class="permission-item">
              <input type="checkbox" id="investments" formControlName="investments">
              <span class="checkmark"></span>
              Investments
            </label>
            <label class="permission-item">
              <input type="checkbox" id="documents" formControlName="documents">
              <span class="checkmark"></span>
              Documents
            </label>
            <label class="permission-item">
              <input type="checkbox" id="requests" formControlName="requests">
              <span class="checkmark"></span>
              Requests
            </label>
          </div>
        </div>
      </div>
      
      <div class="modal-actions">
        <button type="button" (click)="onCancel()">Cancel</button>
        <button class="btn btn-primary" type="submit" [disabled]="userForm.invalid || isLoading()">
          {{ isLoading() ? 'Adding...' : 'Add' }}
        </button>
      </div>
    </form>
  </div>
</div>
